/* eslint-disable react/style-prop-object */
import { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { popupcontext } from "../../../../context/Popupscontext";
import { useGetSpecificRolesQuery } from "../../../../Redux/service/Roles&Permissions/RolesPermissions";
import Popup from "../../../Helpers/Popup/Popup";
import Loader from "../../../Helpers/Loader/Loader";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import RolesInf from "./RolesInf";
import { Segmented } from "antd";
import trans from "../../../../utils";
import RolesPermissions from "./RolesPermissions";
import RolesUsers from "./RolesUsers";

export function RolesPopup({ roleId }) {
	let { setcurrentRoleId, edited } = useContext(popupcontext);
	let { data, isLoading, refetch } = useGetSpecificRolesQuery(roleId, {
		skip: !roleId,
	});
	console.log("DATA Permission", data);
	const closeuser = () => {
		setcurrentRoleId(null);
	};
	useEffect(() => {
		if (edited) {
			refetch();
		}
	}, [edited, refetch]);
	const [type, setType] = useState("General");

	return (
		<Popup show={!!roleId}>
			{isLoading && (
				<div className="loader-container">
					<Loader />
				</div>
			)}
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle headtitle={`${data?.data?.name}`} />
				</Modal.Title>
				<Close
					// eslint-disable-next-line react/style-prop-object
					style="close-32 close"
					close={closeuser}
					img="Close"
				/>
			</Modal.Header>
			<Segmented
				options={[
					{ label: trans("general"), value: "General" },
					{ label: trans("permissions"), value: "Permissions" },
					{ label: trans("users"), value: "Users" },
				]}
				block
				onChange={(e) => setType(e)}
				value={type}
			/>
			<Modal.Body className="modal-body-scrollable">
				{type === "General" && <RolesInf values={data?.data} />}
				{type === "Permissions" && <RolesPermissions values={data?.data} />}
				{type === "Users" && <RolesUsers roleId={roleId} />}
			</Modal.Body>
		</Popup>
	);
}
